import React, { useState } from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import * as styles from '../../../offices/cards/cards.styles';
import Column from '../../../../core/components/column/column.component';
import { CrossAxisAlignment } from '../../../../core/components/flex/flex.component';
import Row from '../../../../core/components/row/row.component';
import type Office from '../../../offices/models/office';

interface Props {
  readonly office: Office;
  readonly isChecked: boolean;
  readonly onClick: (value: string) => void;
}

const OfficeSelectionCard = ({ office, isChecked, onClick }: Props): React.JSX.Element => {
  const [myOffice] = useState<Office>({
    ...office,
  });

  return (
    <div className={style(styles.facilityTypeCard(true))} key={myOffice.id}>
      <Row
        crossAxisAlignment={CrossAxisAlignment.Center}
        className={style(styles.emailBody)}
        onClick={(): void => {
          onClick(myOffice.id ? myOffice.id : '');
        }}
      >
        <Column className={style(styles.facilityTypeBodyText)}>
          <span className={style(styles.cardBody(false, true))}>{myOffice.name}</span>
        </Column>
        <CheckIcon className={style(styles.checkIcon(isChecked))} />
      </Row>
    </div>
  );
};

export default OfficeSelectionCard;
